import { defineStore } from 'pinia';
import Casim from '@/themes/Casim';

export const themes = [
  {
    name: 'casim',
    component: Casim,
  },
] as const;

export type Themes = (typeof themes)[number];

interface ThemeState {
  value: Themes['name'];
}

export const getTheme = (search?: Themes['name']) => {
  const theme = search === undefined ? localStorage.getItem('theme') : search;
  return (
    themes.filter((item) => {
      return item.name === theme;
    })[0] || themes[0]
  );
};

export const useThemeStore = defineStore('theme', {
  state: (): ThemeState => ({
    value: localStorage.getItem('theme') === null ? themes[0].name : getTheme().name,
  }),
  getters: {
    theme(state) {
      if (localStorage.getItem('theme') === null) {
        localStorage.setItem('theme', 'casim');
      }

      return state.value;
    },
  },
  actions: {
    setTheme(theme: Themes['name']) {
      this.value = theme;

      localStorage.setItem('theme', theme);
    },
  },
});
